import React from 'react'
import styled from 'styled-components'
import vars from '../../assets/css/vars/vars'
import { only, down } from 'styled-breakpoints'
import BaseVideo from '../BaseVideo/BaseVideo'
import ScrollAnimation from 'react-animate-on-scroll'
import scrollTo from 'gatsby-plugin-smoothscroll'
import anime from 'animejs'

const Container = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  color: ${vars.COLOR_WHITE_1};
`
const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  // max-width: 40.5rem;
  max-width: 39rem;
  align-self: center;
  ${down('md')} {
    max-width: 100%;
  }
`
const Title = styled.div`
  font-size: 4.2rem;
  font-weight: ${vars.FONT_WEIGHT_MEDIUM};
  margin: 3rem 0;
  line-height: 1.15;
  ${down('md')} {
    font-size: 3.5rem;
    margin-bottom: 6rem;
  }
  ${only('sm')} {
    font-size: 3rem;
    margin-bottom: 4rem;
  }
`
const VideoContainer = styled.div`
  position: relative;
  width: ${vars.CONTENT_WIDTH};
  max-width: calc(100vw - 8rem);
  overflow: hidden;
  height: 0;
`
const VideoInner = styled.div`
  width: 100%;
  height: auto;
  padding-bottom: 4.2rem;
`
const IllustrationContainerSm = styled.div`
  display: none;
  ${only('sm')} {
    width: 100%;
    display: flex;
    align-self: center;
    align-items: flex-start;
    justify-content: center;
    margin: 4rem 0;
    cursor: ${props => (props.clickable ? 'pointer' : 'auto')};
  }
`
const IllustrationContainerSm1 = styled.div`
  display: none;
  ${only('sm')} {
    width: 70%;
    display: flex;
    align-self: center;
    align-items: flex-start;
    justify-content: center;
    margin: 0 0 4rem;
    cursor: ${props => (props.clickable ? 'pointer' : 'auto')};
  }
`
const IllustrationContainerMd = styled.div`
  display: none;
  ${only('md')} {
    width: 100%;
    display: flex;
    align-self: center;
    align-items: flex-start;
    justify-content: center;
    margin-bottom: 6rem;
    cursor: ${props => (props.clickable ? 'pointer' : 'auto')};
  }
`
const Paragraph = styled.div`
  font-size: 2rem;
  font-family: ${vars.FONT_FAMILY_2};
  font-weight: ${vars.FONT_WEIGHT_LIGHT};
  line-height: 1.5;
  ${down('md')} {
    margin-bottom: 0;
    font-size: 2rem;
  }
  ${only('sm')} {
    font-size: 1.6rem;
  }
`
const Spacer = styled.div`
  width: 10%;
  ${down('md')} {
    display: none;
  }
`
const IllustrationContainerLg = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 125rem;
  cursor: ${props => (props.clickable ? 'pointer' : 'auto')};
  ${down('md')} {
    display: none;
  }
`

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = { videoIsOpen: false }
    this.videoContainerRef = React.createRef()
    this.videoInnerRef = React.createRef()
    this.baseVideoRef = React.createRef()
    this.illustrationContainerProps = this.props.videoUrl
      ? {
          onClick: () => this.updateVideoState({ videoIsOpen: true }),
          clickable: true,
        }
      : {}
  }
  setStateAsync(state) {
    return new Promise(resolve => this.setState(state, resolve))
  }
  async updateVideoState({ videoIsOpen }) {
    if (this.isAnimating) return
    this.isAnimating = true
    if (videoIsOpen) {
      await this.setStateAsync({ videoIsOpen })
      // await this.baseVideoRef.current.plyr.play()
      await this.animateVideo('in')
    } else {
      await this.animateVideo('out')
      this.baseVideoRef.current.plyr.stop()
      await this.setStateAsync({ videoIsOpen })
    }
    this.isAnimating = false
  }
  animateVideo(direction) {
    return anime(
      {
        targets: this.videoContainerRef.current,
        height:
          direction === 'in'
            ? ['0px', this.videoInnerRef.current.offsetHeight + 'px']
            : [this.videoContainerRef.current.offsetHeight + 'px', '0px'],
        complete:
          direction === 'in' &&
          (() => (this.videoContainerRef.current.style.height = 'auto')),
        easing: 'easeInOutQuint',
        duration: 600,
      },
      0
    ).finished
  }
  render() {
    return (
      <ScrollAnimation
        animateIn="fade-in-up"
        animateOnce={true}
        style={{ willChange: 'transform, opacity' }}
      >
        <Container id="section-1">
          <Content>
            <Title>{this.props.title}</Title>

            <IllustrationContainerSm1
              onClick={() => {
                scrollTo('#videoAnchor2')
                this.updateVideoState({ videoIsOpen: true })
              }}
            >
              {this.props.illustrationSm1}
            </IllustrationContainerSm1>

            <Paragraph {...this.illustrationContainerProps}>
              {this.props.paragraph}
            </Paragraph>

            {this.props.videoUrl && (
              <VideoContainer
                id={this.props.videoAnchor}
                ref={this.videoContainerRef}
              >
                <VideoInner ref={this.videoInnerRef}>
                  <BaseVideo
                    ref={this.baseVideoRef}
                    src={this.props.videoUrl}
                    onClose={() => {
                      scrollTo('#section1')
                      this.updateVideoState({ videoIsOpen: false })
                    }}
                    theme="white"
                  />
                </VideoInner>
              </VideoContainer>
            )}

            {!this.state.videoIsOpen && (
              <IllustrationContainerSm>
                {this.props.illustrationSm2}
              </IllustrationContainerSm>
            )}

            {!this.state.videoIsOpen && (
              <IllustrationContainerMd>
                {this.props.illustrationMd}
              </IllustrationContainerMd>
            )}
          </Content>
          <Spacer />
          {!this.state.videoIsOpen && (
            <IllustrationContainerLg>
              {this.props.illustrationLg}
            </IllustrationContainerLg>
          )}
        </Container>
      </ScrollAnimation>
    )
  }
}
